import type { FC } from 'react';
import React from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const PauseIcon: FC<IconProps> = props => (
  <BaseIcon {...props}>
    <path d="M9 5a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H9Zm12 0a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2Z" />
  </BaseIcon>
);
